__turbopack_context__.v({
  "allBtn": "WRealizationsTestimonials-module__820puG__allBtn",
  "allWrap": "WRealizationsTestimonials-module__820puG__allWrap",
  "author": "WRealizationsTestimonials-module__820puG__author",
  "authorName": "WRealizationsTestimonials-module__820puG__authorName",
  "authorSector": "WRealizationsTestimonials-module__820puG__authorSector",
  "authorSep": "WRealizationsTestimonials-module__820puG__authorSep",
  "card": "WRealizationsTestimonials-module__820puG__card",
  "cardBody": "WRealizationsTestimonials-module__820puG__cardBody",
  "cardCta": "WRealizationsTestimonials-module__820puG__cardCta",
  "cardImg": "WRealizationsTestimonials-module__820puG__cardImg",
  "cardImgPlaceholder": "WRealizationsTestimonials-module__820puG__cardImgPlaceholder",
  "cardLabel": "WRealizationsTestimonials-module__820puG__cardLabel",
  "cardLogo": "WRealizationsTestimonials-module__820puG__cardLogo",
  "cardMedia": "WRealizationsTestimonials-module__820puG__cardMedia",
  "cardSector": "WRealizationsTestimonials-module__820puG__cardSector",
  "cardTitle": "WRealizationsTestimonials-module__820puG__cardTitle",
  "cardTitleLink": "WRealizationsTestimonials-module__820puG__cardTitleLink",
  "eyebrow": "WRealizationsTestimonials-module__820puG__eyebrow",
  "grid": "WRealizationsTestimonials-module__820puG__grid",
  "header": "WRealizationsTestimonials-module__820puG__header",
  "heading": "WRealizationsTestimonials-module__820puG__heading",
  "pagination": "WRealizationsTestimonials-module__820puG__pagination",
  "root": "WRealizationsTestimonials-module__820puG__root",
  "slide": "WRealizationsTestimonials-module__820puG__slide",
  "swiper": "WRealizationsTestimonials-module__820puG__swiper",
  "testimonial": "WRealizationsTestimonials-module__820puG__testimonial",
  "testimonialsBlock": "WRealizationsTestimonials-module__820puG__testimonialsBlock",
});
